import React from 'react'
import HeroImage from '../assets/heroImage.png'
import { MdOutlineKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-scroll'

const Home = () => {
    return (
        <div name='home' className=' w-full min-h-screen bg-gradient-to-b from-black to-gray-800 via-black -z-10'>
            <div className=' flex flex-col items-center justify-center h-full max-w-screen-lg px-4 mx-auto md:flex-row pt-32'>
                <div className='flex flex-col justify-center  h-full'>
                    <h2 className='text-4xl font-bold text-white sm:text-7xl'>
                        I'm a Full Stack Software Engineer
                    </h2>
                    <p className='py-4 text-gray-500 max-w-md'>
                        Passionate for building web apps.

                    </p>
                    <div className='group '>
                        <Link to='portfolio' smooth duration={500} className='flex items-center px-6 py-3 my-2 text-white rounded-md cursor-pointer  w-fit bg-gradient-to-r from-cyan-500 to-blue-500'>
                            Portfolio
                            <span className='duration-300 group-hover:rotate-90'>
                                <MdOutlineKeyboardArrowRight size={25} className='ml-1' />
                            </span>
                        </Link>
                    </div>
                </div>
                <div className='md:w-2/3 md:flex flex-row items-center justify-center '>
                    <img src={HeroImage} alt="my profile" className=' rounded-lg sm:h-[28vw] h-[50vw]' />
                </div>
            </div>
        </div>
    )
}

export default Home